module.exports = __webpack_public_path__ + "img/placeholder.27ea510f.png";